import { element } from "../../models/element";
import { wine, WineType } from "../../models/wine";
import { beer } from "../../models/beer";
import moment from 'moment';
import { various } from "../../models/various";
import { ITastingMenu } from "../../models/iTastingMenu";


const getValue = (sheet: any, position: any): string => {
    var value = '';
    try {
        value = sheet[position].w;
    }
    catch {
        // console.log("error in get Value");
    }
    return value;
}

const replaceAll = (string: any, search: any, replace: any) => {
    return string.split(search).join(replace);
}

export const getMenu = (sheet: any): element[][] => {
    var antipasti: element[] = [];
    var primi: element[] = [];
    var secondi: element[] = [];
    var contorni: element[] = [];
    var dolci: element[] = [];
    var returnValue = [antipasti, primi, secondi, contorni, dolci];
    var parsed = "";
    var antipastiIndex: boolean = false;
    var primiIndex: boolean = false;
    var secondiIndex: boolean = false;
    var contorniIndex: boolean = false;
    var dolciIndex: boolean = false;
    var index = 1;
    var aValue = "";
    var bValue = "";
    var cValue = "";
    var dValue = "";
    while (parsed.trim().toUpperCase() != "FINE") {
        // console.log(parsed);
        aValue = getValue(sheet, `A${index}`);
        bValue = getValue(sheet, `B${index}`);
        cValue = getValue(sheet, `C${index}`);
        dValue = getValue(sheet, `D${index}`);

        if (aValue.toUpperCase() == "ANTIPASTI")
            antipastiIndex = true;
        else if (aValue.trim().toUpperCase() == "PRIMI")
            primiIndex = true;
        else if (aValue.trim().toUpperCase() == "SECONDI")
            secondiIndex = true;
        else if (aValue.trim().toUpperCase() == "CONTORNI")
            contorniIndex = true;
        else if (aValue.trim().toUpperCase() == "DOLCI")
            dolciIndex = true;
        else if (aValue.trim().toUpperCase() == "FINE") { }
        else {
            var value: element = { prodotto: aValue, descrizione: bValue, price: + cValue, allergeni: !!dValue ? dValue.split(';') : [] };
            if (dolciIndex)
                dolci.push(value);
            else if (contorniIndex)
                contorni.push(value);
            else if (secondiIndex)
                secondi.push(value);
            else if (primiIndex)
                primi.push(value);
            else if (antipastiIndex)
                antipasti.push(value);
        }
        parsed = aValue;
        ++index;
    }
    return returnValue;
}

export const getDegu = (sheet: any): ITastingMenu => {
    var value = getValue(sheet, 'A2');
    value = replaceAll(value, '/*', '</b>');
    value = replaceAll(value, '*', '<b>');
    value = replaceAll(value, '/_', '</i>');
    value = replaceAll(value, '_', '<i>');
    value = replaceAll(value, '/%', '</big>');
    value = replaceAll(value, '%', '<big>');
    value = replaceAll(value, '/$', '</small>');
    value = replaceAll(value, '$', '<small>');
    value = replaceAll(value, '//', '<br>');
    var allergens = getValue(sheet, 'A5');
    var result: ITastingMenu = {
        menu: value,
        allergens: !!allergens ? allergens.split(';') : []
    }
    return result;
}

export const getWines = (sheet: any): wine[] => {
    var wines: wine[] = [];

    var rossiIndex: boolean = false;
    var bianchiIndex: boolean = false;
    var rosatiIndex: boolean = false;
    var bollicineIndex: boolean = false;
    var viniDolciIndex: boolean = false;
    var parsed = "";
    var aValue = "";
    var bValue = "";
    var cValue = "";
    var dValue = "";
    var eValue = "";
    var fValue = "";
    var gValue = "";
    var hValue = "";
    var index = 1;
    while (parsed.trim().toUpperCase() != "FINE") {
        aValue = getValue(sheet, `A${index}`);
        bValue = getValue(sheet, `B${index}`);
        cValue = getValue(sheet, `C${index}`);
        dValue = getValue(sheet, `D${index}`);
        eValue = getValue(sheet, `E${index}`);
        fValue = getValue(sheet, `F${index}`);
        gValue = getValue(sheet, `G${index}`);
        hValue = getValue(sheet, `H${index}`);
        if (aValue.toUpperCase() == "ROSSI")
            rossiIndex = true;
        else if (aValue.trim().toUpperCase() == "BIANCHI")
            bianchiIndex = true;
        else if (aValue.trim().toUpperCase() == "ROSATI")
            rosatiIndex = true;
        else if (aValue.trim().toUpperCase() == "BOLLICINE")
            bollicineIndex = true;
        else if (aValue.trim().toUpperCase() == "DOLCI")
            viniDolciIndex = true;
        else if (aValue.trim().toUpperCase() == "FINE") { }
        else {
            var wine: wine =
            {
                nome: aValue,
                cantina: bValue,
                descrizione: cValue,
                caratteristiche: !!dValue ? dValue.split(';') : [],
                vol: eValue,
                annata: fValue,
                bottlePrice: + gValue,
                chalicePrice: +hValue
            };
            if (viniDolciIndex)
                wine.type = WineType.Dolci;
            else if (bollicineIndex)
                wine.type = WineType.Bollicine;
            else if (rosatiIndex)
                wine.type = WineType.Rosati;
            else if (bianchiIndex)
                wine.type = WineType.Bianchi;
            else if (rossiIndex)
                wine.type = WineType.Rossi;

            wines.push(wine);
        }
        parsed = aValue;
        ++index;
    }
    return wines;
}

export const getBeers = (sheet: any): beer[] => {

    var beers: beer[] = [];
    var parsed = "";
    var aValue = "";
    var bValue = "";
    var cValue = "";
    var dValue = "";
    var eValue = "";
    var fValue = "";
    var gValue = "";
    var hValue = "";
    var iValue = "";
    var jValue = "";
    var index = 2;
    var parsed = "";
    while (parsed.toUpperCase() != "FINE") {
        if (parsed != "FINE") {

            aValue = getValue(sheet, `A${index}`);
            bValue = getValue(sheet, `B${index}`);
            cValue = getValue(sheet, `C${index}`);
            dValue = getValue(sheet, `D${index}`);
            eValue = getValue(sheet, `E${index}`);
            fValue = getValue(sheet, `F${index}`);
            gValue = getValue(sheet, `G${index}`);
            hValue = getValue(sheet, `H${index}`);
            iValue = getValue(sheet, `I${index}`);
            jValue = getValue(sheet, `J${index}`);
            var beer: beer = { nome: aValue, birrificio: bValue, descrizione: cValue, vol: dValue, price33: + eValue, price75: +fValue, q1: gValue, priceQ1: +hValue, q2: iValue, priceQ2: + jValue };
            beers.push(beer);
            parsed = aValue;
            ++index;
        }
    }

    // var birrifici: any[] = [];
    // var grouped = beers.reduce(function (r, a) {
    //     r[a.birrificio] = r[a.birrificio] || [];
    //     if (!birrifici.includes(a.birrificio))
    //         birrifici.push(a.birrificio);
    //     r[a.birrificio].push(a);
    //     return r;
    // }, Object.create(null));
    // birrifici.forEach(element => {
    //     if (!!element) {
    //         var wrapper: beerWrapper = { birrificio: element, birre: grouped[element] };
    //         beerWrapper.push(wrapper);
    //     }
    // });
    // return beerWrapper;
    return beers;
}

export const getBeerSizes = (beer: beer) => {
    var returnString = "";
    if (!!beer.price33)
        returnString += ` 33.cl ${beer.price33}€`;
    if (!!beer.price75)
        returnString += ` 75.cl ${beer.price75}€`;
    if (!!beer.q1 && !!beer.priceQ1)
        returnString += ` ${beer.q1}.cl ${beer.priceQ1}€`;
    if (!!beer.q2 && !!beer.priceQ2)
        returnString += ` ${beer.q2}.cl ${beer.priceQ2}€`;
    return returnString;
}

export const getDate = (sheet: any): string => {

    var day = getValue(sheet, 'B2');
    var month = getValue(sheet, 'C2');
    var year = getValue(sheet, 'D2');
    var stringDate = `${year}-${month}-${day}T00:00:00`;
    console.log(`stringDate from xls file ${stringDate}`);
    var date = moment(stringDate).locale("it").format("LL");

    return date;
}

export const getDetails = (sheet: any): various => {
    var value: various = {
        coperto: getValue(sheet, 'A2'),
        caffe: getValue(sheet, 'B2'),
        acqua75: getValue(sheet, 'C2'),
        vino1: getValue(sheet, 'D2'),
        vinoMezzo: getValue(sheet, 'E2'),
        vinoQuarto: getValue(sheet, 'F2'),
        bibite: getValue(sheet, 'G2'),
        prezzoDegu: getValue(sheet, 'H2')
    };
    return value;
}
export const getAllergensList = (sheet: any) => {
    var max = 14;
    var allergens: [number, string][] = [];
    for (var i = 1; i <= max; i++) {
        var value = getValue(sheet, `B${i}`);
        allergens.push([i, value]);
    }
    return allergens;
}